import CurrencyInput, { FormikCurrencyInput } from "./CurrencyInput";
import MultilineInput, { FormikMultilineInput } from "./MultilineInput";
import TextInput, { FormikTextInput } from "./TextInput";

export default {
  Currency: CurrencyInput,
  Multiline: MultilineInput,
  Text: TextInput,
  Formik: {
    Currency: FormikCurrencyInput,
    Multiline: FormikMultilineInput,
    Text: FormikTextInput,
  },
};
